module.exports = __webpack_public_path__ + "img/backHome1.77681e3b.jpg";